import SecretariaActionTypes from "./action-types";

const initState = {
    secretaria: {}
}

const secretariaReducer = (state = initState, action) => {
    switch (action.type) {
        case SecretariaActionTypes.SECRETARIA_SELECTED:
            return { ...state, secretaria: action.payload };
        default: return state;
    }
}

export default secretariaReducer;